export default __webpack_public_path__ + "static/media/discover-story-banner.9e073d31.jpg";